// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundReplenishmentCreepPercentPropertyDto
 */
export interface IPrefundReplenishmentCreepPercentPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundReplenishmentCreepPercentPropertyDto
     */
    prefund_replenishment_creep_percent?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundReplenishmentCreepPercentPropertyDto
     */
    prefund_replenishment_creep_percent_state?: IPrefundReplenishmentCreepPercentPropertyDtoPrefundReplenishmentCreepPercentStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPrefundReplenishmentCreepPercentPropertyDtoPrefundReplenishmentCreepPercentStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPrefundReplenishmentCreepPercentPropertyDto interface.
 */
export function instanceOfIPrefundReplenishmentCreepPercentPropertyDto(value: object): value is IPrefundReplenishmentCreepPercentPropertyDto {
    return true;
}

export function IPrefundReplenishmentCreepPercentPropertyDtoFromJSON(json: any): IPrefundReplenishmentCreepPercentPropertyDto {
    return IPrefundReplenishmentCreepPercentPropertyDtoFromJSONTyped(json, false);
}

export function IPrefundReplenishmentCreepPercentPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundReplenishmentCreepPercentPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'prefund_replenishment_creep_percent': json['prefund_replenishment_creep_percent'] == null ? undefined : json['prefund_replenishment_creep_percent'],
        'prefund_replenishment_creep_percent_state': json['prefund_replenishment_creep_percent_state'] == null ? undefined : json['prefund_replenishment_creep_percent_state'],
    };
}

export function IPrefundReplenishmentCreepPercentPropertyDtoToJSON(json: any): IPrefundReplenishmentCreepPercentPropertyDto {
    return IPrefundReplenishmentCreepPercentPropertyDtoToJSONTyped(json, false);
}

export function IPrefundReplenishmentCreepPercentPropertyDtoToJSONTyped(value?: IPrefundReplenishmentCreepPercentPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prefund_replenishment_creep_percent': value['prefund_replenishment_creep_percent'],
        'prefund_replenishment_creep_percent_state': value['prefund_replenishment_creep_percent_state'],
    };
}

